import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage } from 'react-intl';

import theme from '../../theme';

const Loading = ({ isLoading, content, variant }) => {

  return (
    <>
      {
        variant !== 'inside' ? (
          <Backdrop
            open={isLoading}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              color: '#fff',
              zIndex: 2500
            }}
          >
            <CircularProgress color="inherit" />
            {content &&
              <Typography mt={2}>
                <FormattedMessage id={content} />
              </Typography>
            }
          </Backdrop>
        ) : (
          <Backdrop
            sx={{
              position: 'absolute',
              zIndex: 500,
              backgroundColor: 'transparent',
              color: theme.palette.grey.dark
            }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )
      }
    </>
  )
}

export default Loading;